import { render, staticRenderFns } from "./Crop.vue?vue&type=template&id=2b448072&"
import script from "./Crop.vue?vue&type=script&lang=js&"
export * from "./Crop.vue?vue&type=script&lang=js&"
import style0 from "./Crop.vue?vue&type=style&index=0&id=2b448072&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports